export default [
    {
      value: "ExecutoraCriadora",
      text: "Executora criadora",
    },
    {
      value: "Cooperada",
      text: "Cooperada",
    },
];